import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function CTAButton({ to, label, testId, size = "default", onClick, type = "link", wrap = false, disabled = false }) {
  const classes =
    size === "large"
      ? "inline-flex items-center gap-3 bg-accent text-paper px-10 py-5 text-sm md:text-base uppercase tracking-[0.15em] font-mono hover:bg-accentHover hover:-translate-y-0.5 transition-all duration-300 group focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-paper focus-visible:outline-none disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-accent disabled:hover:translate-y-0"
      : `inline-flex items-center gap-2 bg-accent text-paper px-5 py-2.5 text-xs uppercase tracking-[0.15em] font-mono hover:bg-accentHover hover:-translate-y-0.5 transition-all duration-300 group ${wrap ? "w-full justify-between text-left" : "whitespace-nowrap"} focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-paper focus-visible:outline-none disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-accent disabled:hover:translate-y-0`;

  const content = (
    <>
      <span>{label}</span>
      <ArrowRight
        size={size === "large" ? 20 : 14}
        className="transition-transform duration-300 group-hover:translate-x-1"
      />
    </>
  );

  if (type === "submit") {
    return (
      <button type="submit" onClick={onClick} data-testid={testId} className={classes} disabled={disabled}>
        {content}
      </button>
    );
  }

  if (type === "button") {
    return (
      <button type="button" onClick={onClick} data-testid={testId} className={classes} disabled={disabled}>
        {content}
      </button>
    );
  }

  return (
    <Link to={to} data-testid={testId} className={classes} onClick={onClick}>
      {content}
    </Link>
  );
}
